var A = window.RI_ASSETS || '';
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var mq = window.matchMedia('(max-width: 900px)');
  var clamp = function(v, a, b){ return Math.max(a, Math.min(b, v)); };
  var SVGNS = 'http://www.w3.org/2000/svg';

  // ---- the 3D box
  var box = document.getElementById('box');
  try {
    window.__ribox = RIBox.mount(box, { base: A + 'ri-', onInteract: function(){ box.classList.add('is-touched'); } });
  } catch (e) {
    box.innerHTML = '<img src="' + A + 'ri-box-fallback.png" alt="The Retail Investor box" style="width:100%;height:100%;object-fit:contain;">';
  }

  // ---- 1. the hand: cards on an arc that never ends. Fans open on first sight; the centre card comes right up to you.
  (function(){
    var hand = document.getElementById('hand'), stage = hand.querySelector('.hand__stage'), slots = [].slice.call(hand.querySelectorAll('.hslot'));
    var n = slots.length;
    // the hand opens on The Bull Statue Sits Down
    var start = 0; slots.forEach(function(sl, i){ if (/news-18/.test(sl.querySelector('.card').dataset.large || '')) start = i; });
    var g = {}, pos = start, target = start, spread = 0, opened = false, dragging = false, moved = 0, lastX = 0, vel = 0, raf = 0;
    function geometry(){
      var W = stage.clientWidth, ratio = parseFloat(hand.dataset.ratio);
      var cw = mq.matches ? Math.min(230, W * 0.52) : Math.min(parseFloat(hand.dataset.cardW), W * 0.19);
      var ch = cw * ratio, gap = mq.matches ? 14 : 22;
      var R = Math.max(1150, W * 1.05), S = mq.matches ? 1.3 : 1.55;
      g = { W: W, cw: cw, ch: ch, step: (cw + gap) / R, R: R, vis: mq.matches ? 1.8 : 2.8, S: S, lift: (S - 1) * ch / 2 + 6 };
      hand.style.setProperty('--card-w', cw + 'px');
      stage.style.setProperty('--stage-h', Math.round(ch * S + 12 + R * (1 - Math.cos(g.step * g.vis)) * 0.6) + 'px');
      slots.forEach(function(sl){ sl.style.width = cw + 'px'; });
    }
    function wrap(i){ var t = ((i - pos) % n + n) % n; if (t > n / 2) t -= n; return t; }
    function render(){
      var cx = g.W / 2 - g.cw / 2;
      for (var i = 0; i < n; i++) {
        var t = wrap(i), a = Math.abs(t);
        var sc = 1 + (g.S - 1) * Math.max(0, 1 - a);                      // the centre card comes forward, over its neighbours
        var th = t * g.step * spread;
        var x = g.R * Math.sin(th), y = g.R * (1 - Math.cos(th)) + (1 - spread) * 40 + g.lift;
        var fade = clamp(1 - (a - g.vis) / 1.0, 0, 1) * (opened ? 1 : spread);
        var sl = slots[i];
        sl.style.transform = 'translate(' + (cx + x).toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + (th * 180 / Math.PI).toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
        sl.style.opacity = fade.toFixed(3);
        sl.style.zIndex = String(100 - Math.round(a * 10));
        sl.style.pointerEvents = fade > 0.4 ? '' : 'none';
        if (a < 0.5 && !sl.classList.contains('is-center')) { var big = sl.querySelector('.card').dataset.large; if (big) { var pre = new Image(); pre.src = big; } }
        sl.classList.toggle('is-center', a < 0.5);
        sl._rot = th * 180 / Math.PI; sl._scale = sc;
      }
    }
    function loop(){
      raf = 0;
      var busy = false;
      if (!dragging) {
        if (Math.abs(vel) > 0.0008) { pos += vel; vel *= 0.92; busy = true; }
        else { var d = target - pos; if (Math.abs(d) > 0.002) { pos += d * 0.16; busy = true; } else { pos = target; } }
      }
      render();
      if (busy || dragging) raf = requestAnimationFrame(loop);
    }
    function kick(){ if (!raf) raf = requestAnimationFrame(loop); }
    function settle(){ target = Math.round(pos + vel * 8); vel = 0; kick(); }
    function open(){
      if (opened) return; opened = true;
      if (reduced) { spread = 1; render(); return; }
      var t0 = performance.now();
      (function tick(now){
        var p = clamp((now - t0) / 1400, 0, 1), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        spread = e; render();
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    }
    var downSlot = null;
    stage.addEventListener('pointerdown', function(e){ if (e.button !== 0 && e.pointerType === 'mouse') return; downSlot = e.target.closest('.hslot'); dragging = true; moved = 0; lastX = e.clientX; vel = 0; stage.classList.add('is-dragging'); stage.setPointerCapture && stage.setPointerCapture(e.pointerId); });
    stage.addEventListener('pointermove', function(e){ if (!dragging) return; var dx = e.clientX - lastX; lastX = e.clientX; moved += Math.abs(dx); var dp = -dx / (g.cw + 22); pos += dp; vel = dp * 0.9; kick(); });
    function endDrag(){ if (!dragging) return; dragging = false; stage.classList.remove('is-dragging'); settle(); }
    stage.addEventListener('pointerup', endDrag); stage.addEventListener('pointercancel', endDrag); stage.addEventListener('lostpointercapture', endDrag);
    // a click on a card to the right goes right, to the left goes left; the centre card comes closer
    stage.addEventListener('click', function(e){
      var sl = downSlot || e.target.closest('.hslot'); downSlot = null;
      if (moved > 8) { e.stopPropagation(); e.preventDefault(); return; }
      if (!sl) return;
      e.stopPropagation();
      var t = Math.round(wrap(slots.indexOf(sl)));
      if (t !== 0) { window.RINear.clear(); target = Math.round(pos) + t; kick(); }
      else if (window.RINear.isNear(sl)) window.RINear.clear();
      else window.RINear.bring(sl, 2.1);
    }, true);
    stage.addEventListener('wheel', function(e){ if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 4) { e.preventDefault(); target = Math.round(target + Math.sign(e.deltaX)); kick(); } }, { passive: false });
    stage.addEventListener('keydown', function(e){ if (e.key === 'ArrowRight') { target = Math.round(target) + 1; kick(); e.preventDefault(); } if (e.key === 'ArrowLeft') { target = Math.round(target) - 1; kick(); e.preventDefault(); } });
    geometry(); render();
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ geometry(); render(); }, 120); });
    new IntersectionObserver(function(en){ if (en[0].isIntersecting) open(); }, { threshold: 0.3 }).observe(hand);
  })();

  // ---- 2. the evidence board: cards pinned to felt, drag them around
  (function(){
    var board = document.getElementById('board'), svg = board.querySelector('.board__strings'), gP = document.getElementById('pins');
    var items = [].slice.call(board.querySelectorAll('.evid'));
    var W = 0, H = 0, narrow = false, pins = {}, z = 10, drag = null;
    items.forEach(function(el){
      var gr = document.createElementNS(SVGNS, 'g');
      var c = document.createElementNS(SVGNS, 'circle'); c.setAttribute('r', '7.5'); c.setAttribute('class', 'spin'); c.style.transitionDelay = 'calc(' + (el.style.getPropertyValue('--d') || '0s') + ' + .3s)';
      var d = document.createElementNS(SVGNS, 'circle'); d.setAttribute('r', '2'); d.setAttribute('class', 'spin-dot');
      gr.appendChild(c); gr.appendChild(d); gP.appendChild(gr); pins[el.dataset.id] = { g: gr, c: c, d: d };
    });
    function pinPos(el){
      // the invisible anchor sits on the card's top edge and moves with every transform the card gets
      var pr = el.querySelector('.pin').getBoundingClientRect(), br = board.getBoundingClientRect();
      return [pr.left + pr.width / 2 - br.left, pr.top + pr.height / 2 - br.top];
    }
    function place(el){ var cx = el._x / 100 * W, cy = el._y / 100 * H; el.style.transform = 'translate(' + (cx - el._w / 2).toFixed(1) + 'px,' + (cy - el._h / 2).toFixed(1) + 'px) rotate(' + el._r + 'deg)'; el._rot = el._r; el._scale = 1; }
    function strings(){
      // pins sit on each card's top edge and follow it wherever it goes
      items.forEach(function(el){ if (el._hidden) return; var p = pinPos(el), pin = pins[el.dataset.id]; pin.c.setAttribute('cx', p[0].toFixed(1)); pin.c.setAttribute('cy', p[1].toFixed(1)); pin.d.setAttribute('cx', (p[0] - 1.5).toFixed(1)); pin.d.setAttribute('cy', (p[1] - 1.5).toFixed(1)); });
    }
    // keep the pins glued to the cards while they animate (entry, flip, come closer, back)
    var track = 0;
    function follow(ms){ var t0 = performance.now(); cancelAnimationFrame(track); (function f(now){ strings(); if (now - t0 < ms) track = requestAnimationFrame(f); })(t0); }
    function size(){
      W = board.clientWidth; narrow = W < 700; H = Math.round(W * (narrow ? 2.0 : 0.54));
      board.style.height = H + 'px'; svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      items.forEach(function(el){
        var d = el.dataset; el._w = W * parseFloat(narrow ? d.mw : d.w) / 100; el._h = el._w * parseFloat(d.ratio);
        el._hidden = !!(narrow && d.mhide); el.style.display = el._hidden ? 'none' : ''; pins[d.id].g.style.display = el._hidden ? 'none' : '';
        if (!el._placed || el._narrow !== narrow) { el._x = parseFloat(narrow ? d.mx : d.x); el._y = parseFloat(narrow ? d.my : d.y); el._r = parseFloat(narrow ? d.mr : d.r); el._placed = true; el._narrow = narrow; }
        el.style.width = el._w.toFixed(1) + 'px'; place(el);
      });
      strings();
    }
    size();
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(size, 120); });
    new IntersectionObserver(function(en){ if (!en[0].isIntersecting) return; board.classList.add('is-in'); follow(2200); }, { threshold: 0.3 }).observe(board);
    // a card that comes up close keeps its pin
    board.addEventListener('rinear', function(){ follow(800); });
    board.addEventListener('click', function(e){ var ev = e.target.closest('.evid'); if (ev) follow(900); }, true);
    window.addEventListener('scroll', function(){ if (board.querySelector('.is-near')) follow(700); }, { passive: true });
    if (finePointer) {
      items.forEach(function(el){
        el.addEventListener('pointerdown', function(e){
          if (e.button !== 0 || el.classList.contains('is-near')) return;
          drag = { el: el, sx: e.clientX, sy: e.clientY, ox: el._x, oy: el._y, moved: 0 };
          el.classList.add('is-drag'); el.style.zIndex = String(++z);
          el.setPointerCapture && el.setPointerCapture(e.pointerId);
        });
        el.addEventListener('click', function(e){ if (el._suppress) { e.stopPropagation(); e.preventDefault(); el._suppress = false; } }, true);
      });
      window.addEventListener('pointermove', function(e){
        if (!drag) return;
        var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy; drag.moved = Math.max(drag.moved, Math.abs(dx) + Math.abs(dy));
        var el = drag.el;
        el._x = clamp(drag.ox + dx / W * 100, el._w / 2 / W * 100 + 1, 100 - el._w / 2 / W * 100 - 1);
        el._y = clamp(drag.oy + dy / H * 100, el._h / 2 / H * 100 + 1, 100 - el._h / 2 / H * 100 - 1);
        place(el); strings();
      });
      var endDrag = function(){ if (!drag) return; var el = drag.el; el.classList.remove('is-drag'); if (drag.moved > 6) el._suppress = true; else { place(el); strings(); } drag = null; };
      window.addEventListener('pointerup', endDrag); window.addEventListener('pointercancel', endDrag);
    } else {
    }
  })();

  // ---- tilt + glare + lift on hover (desktop only)
  if (finePointer && !reduced) {
    document.querySelectorAll('.card').forEach(function(card){
      var tilt = card.querySelector('.tilt'), glare = card.querySelector('.glare'), host = card.closest('.hslot, .evid');
      card.addEventListener('pointerenter', function(){ if (host) host.classList.add('is-lifted'); if (card.dataset.large && !card._pre) { card._pre = true; var pre = new Image(); pre.src = card.dataset.large; } });
      card.addEventListener('pointermove', function(e){
        if (host && host.classList.contains('is-drag')) return;
        var r = card.getBoundingClientRect(), nx = (e.clientX - r.left) / r.width - .5, ny = (e.clientY - r.top) / r.height - .5;
        tilt.style.transform = 'rotateX(' + (-ny * 14).toFixed(2) + 'deg) rotateY(' + (nx * 16).toFixed(2) + 'deg)';
        if (glare) { glare.style.setProperty('--gx', ((nx + .5) * 100).toFixed(1) + '%'); glare.style.setProperty('--gy', ((ny + .5) * 100).toFixed(1) + '%'); }
      });
      card.addEventListener('pointerleave', function(){ tilt.style.transform = ''; if (host) host.classList.remove('is-lifted'); });
      card.addEventListener('focus', function(){ if (host) host.classList.add('is-lifted'); });
      card.addEventListener('blur', function(){ if (host) host.classList.remove('is-lifted'); });
    });
  }

  // ---- come closer: click a card and it comes up to you; click anything else, or scroll, and it goes back
  window.RINear = (function(){
    var near = null;
    function clear(){ if (!near) return; var h = near; near = null; h.classList.remove('is-near'); h.querySelector('.floater').style.transform = ''; h.dispatchEvent(new CustomEvent('rinear', { bubbles: true, detail: { on: false } })); }
    function bring(host, total){
      clear();
      var card = host.querySelector('.card'), img = card.querySelector('.face'), fl = host.querySelector('.floater');
      if (card.dataset.large && !img._hi) { img._hi = true; img.src = card.dataset.large; }
      var r = card.getBoundingClientRect(), s0 = host._scale || 1, rot = host._rot || 0;
      var vw = window.innerWidth, vh = window.innerHeight;
      var k = Math.min(total, (vw - 28) / (r.width / s0), (vh - 28) / (r.height / s0)); // never bigger than the screen
      var w = r.width / s0 * k, h = r.height / s0 * k;
      var tx = clamp(vw / 2, w / 2 + 12, vw - w / 2 - 12), ty = clamp(vh / 2, h / 2 + 12, vh - h / 2 - 12);
      var dx = tx - (r.left + r.width / 2), dy = ty - (r.top + r.height / 2);
      var rad = -rot * Math.PI / 180, lx = (dx * Math.cos(rad) - dy * Math.sin(rad)) / s0, ly = (dx * Math.sin(rad) + dy * Math.cos(rad)) / s0;
      fl.style.transform = 'translate(' + lx.toFixed(1) + 'px,' + ly.toFixed(1) + 'px) rotate(' + (-rot).toFixed(2) + 'deg) scale(' + (k / s0).toFixed(3) + ')';
      host.classList.add('is-near'); near = host;
      host.dispatchEvent(new CustomEvent('rinear', { bubbles: true, detail: { on: true } }));
    }
    function toggle(host, total){ return function(e){ if (host._suppress) return; e.stopPropagation(); if (host.classList.contains('is-down')) { host.classList.remove('is-down'); return; } if (host.classList.contains('is-near')) clear(); else bring(host, total); }; }
    document.querySelectorAll('.evid').forEach(function(host){ host.addEventListener('click', toggle(host, 2.1)); });
    document.addEventListener('click', function(e){ if (near && !near.contains(e.target)) clear(); });
    window.addEventListener('scroll', function(){ clear(); }, { passive: true });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') clear(); });
    return { clear: clear, bring: bring, isNear: function(h){ return h === near; } };
  })();

  // ---- the rulebook reader
  (function(){
    var reader = document.getElementById('reader'), img = document.getElementById('readerImg'), count = document.getElementById('readerCount'), page = 1, N = 8;
    function show(pg){ page = ((pg - 1 + N) % N) + 1; img.src = A + 'ri-rules-page-' + page + '.jpg'; count.textContent = 'Page ' + page + ' of ' + N; var pre = new Image(); pre.src = A + 'ri-rules-page-' + (page % N + 1) + '.jpg'; }
    function openR(){ show(1); reader.classList.add('is-open'); document.body.style.overflow = 'hidden'; reader.querySelector('.reader__btn--next').focus(); }
    function closeR(){ reader.classList.remove('is-open'); document.body.style.overflow = ''; document.getElementById('openBook').focus(); }
    document.getElementById('openBook').addEventListener('click', openR);
    reader.querySelector('.reader__close').addEventListener('click', closeR);
    reader.querySelector('.reader__btn--prev').addEventListener('click', function(e){ e.stopPropagation(); show(page - 1); });
    reader.querySelector('.reader__btn--next').addEventListener('click', function(e){ e.stopPropagation(); show(page + 1); });
    img.addEventListener('click', function(e){ e.stopPropagation(); var r = img.getBoundingClientRect(); show(e.clientX < r.left + r.width / 2 ? page - 1 : page + 1); });
    reader.addEventListener('click', function(e){ if (e.target === reader || e.target === count) closeR(); });
    document.addEventListener('keydown', function(e){ if (!reader.classList.contains('is-open')) return; if (e.key === 'Escape') closeR(); if (e.key === 'ArrowRight') show(page + 1); if (e.key === 'ArrowLeft') show(page - 1); });
    var sx = null; reader.addEventListener('pointerdown', function(e){ sx = e.clientX; }); reader.addEventListener('pointerup', function(e){ if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 50) show(dx < 0 ? page + 1 : page - 1); });
    window.RIReader = { open: openR };
  })();

  // ---- what's in the box: a closer look. Boards come up big; decks fan out into a grid where nothing overlaps.
  (function(){
    var box = document.getElementById('kitbox'), stage = document.getElementById('kitStage'), current = null, items = [];
    var CARD = 'kitbox__item kitbox__item--card';
    var DATA = {
      portfolio: { kind: 'flat', src: A + 'ri-kit-portfolio-large.jpg', w: 1700, h: 1597 },
      market:    { kind: 'flat', src: A + 'ri-kit-market-large.jpg', w: 1100, h: 1349 },
      tracker:   { kind: 'flat', src: A + 'ri-kit-tracker-large.jpg', w: 1700, h: 645 },
      stock:     { kind: 'fan', cls: CARD + ' kitbox__item--stock', ratio: 511 / 1100, maxW: 560, items: [A + 'ri-cards-stock-12-2x.jpg', A + 'ri-cards-stock-07-2x.jpg', A + 'ri-cards-stock-14-2x.jpg'] },
      dd:        { kind: 'fan', cls: CARD, ratio: 1820 / 1300, maxW: 400, items: [A + 'ri-cards-dd-01-2x.jpg', A + 'ri-cards-dd-40-2x.jpg', A + 'ri-cards-dd-46-2x.jpg'] },
      news:      { kind: 'fan', cls: CARD, ratio: 2605 / 1520, maxW: 380, items: [A + 'ri-cards-news-01-2x.jpg', A + 'ri-cards-news-03-2x.jpg', A + 'ri-cards-news-31-2x.jpg'] },
      aids:      { kind: 'fan', cls: CARD, ratio: 1545 / 900, maxW: 460, items: [A + 'ri-kit-aid.jpg'] },
      bills:     { kind: 'fan', cls: 'kitbox__item kitbox__item--flat', ratio: 412 / 900, maxW: 520, items: [A + 'ri-kit-bill-1.jpg', A + 'ri-kit-bill-2.jpg', A + 'ri-kit-bill-3.jpg', A + 'ri-kit-bill-4.jpg', A + 'ri-kit-bill-5.jpg', A + 'ri-kit-bill-6.jpg'] },
      pieces:    { kind: 'fan', cls: 'kitbox__item kitbox__item--bare', ratio: 1, maxW: 250, items: [A + 'ri-kit-piece_die.webp', A + 'ri-kit-piece_chip.webp', A + 'ri-kit-piece_moon.webp', A + 'ri-kit-piece_rocket.webp', A + 'ri-kit-piece_bull_head.webp', A + 'ri-kit-piece_robot_drawn.webp'] }
    };
    function layout(n, ratio, maxW){
      var vw = window.innerWidth, vh = window.innerHeight;
      var pad = clamp(vw * 0.03, 16, 40), gap = clamp(vw * 0.02, 12, 28), top = 24, bottom = 48;
      var availW = vw - 2 * pad, availH = vh - top - bottom - 2 * pad, best = null;
      for (var cols = 1; cols <= n; cols++) {
        var rows = Math.ceil(n / cols);
        var w = Math.min(maxW, (availW - gap * (cols - 1)) / cols, ((availH - gap * (rows - 1)) / rows) / ratio);
        if (!best || w > best.w + 0.5) best = { cols: cols, rows: rows, w: w };
      }
      var h = best.w * ratio, out = [];
      if (n > 1 && vw < 700 && best.w < 0.6 * maxW) {
        // a phone: one readable column you scroll through instead of a grid of postage stamps
        var cw = Math.min(maxW, availW), ch = cw * ratio, y = 72;   // start below the close button
        for (var j = 0; j < n; j++) { out.push({ x: (vw - cw) / 2, y: y, w: cw, h: ch }); y += ch + gap; }
        out.scroll = y + bottom;
        return out;
      }
      var totalH = best.rows * h + gap * (best.rows - 1), y0 = top + pad + (availH - totalH) / 2;
      for (var i = 0; i < n; i++) {
        var c = i % best.cols, r = Math.floor(i / best.cols);
        var inRow = (r === best.rows - 1) ? n - r * best.cols : best.cols;
        var rowW = inRow * best.w + gap * (inRow - 1), x0 = (vw - rowW) / 2;
        out.push({ x: x0 + c * (best.w + gap), y: y0 + r * (h + gap), w: best.w, h: h });
      }
      return out;
    }
    function positions(spec){
      if (spec.kind === 'fan') return layout(spec.items.length, spec.ratio, spec.maxW);
      var vw = window.innerWidth, vh = window.innerHeight, k = Math.min((vw - 32) / spec.w, (vh - 96) / spec.h, 1);
      var w = spec.w * k, h = spec.h * k;
      return [{ x: (vw - w) / 2, y: 40 + (vh - 72 - h) / 2, w: w, h: h }];
    }
    function apply(animate){
      var spec = DATA[current]; if (!spec) return;
      var pos = positions(spec), vw = window.innerWidth, vh = window.innerHeight;
      var sp = stage.querySelector('.kitbox__spacer');
      stage.classList.toggle('is-scroll', !!pos.scroll);
      if (pos.scroll) { if (!sp) { sp = document.createElement('div'); sp.className = 'kitbox__spacer'; stage.appendChild(sp); } sp.style.height = pos.scroll + 'px'; }
      else if (sp) sp.remove();
      items.forEach(function(el, i){
        var p = pos[i]; el.style.width = p.w.toFixed(1) + 'px'; el.style.height = p.h.toFixed(1) + 'px';
        var done = 'translate(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px) scale(1) rotate(0deg)';
        if (animate && !reduced) {
          // start as a stack in the middle, then fan out
          el.style.transition = 'none';
          el.style.transform = 'translate(' + (vw / 2 - p.w / 2 + (i - (items.length - 1) / 2) * 6).toFixed(1) + 'px,' + (vh / 2 - p.h / 2).toFixed(1) + 'px) scale(.55) rotate(' + ((i - (items.length - 1) / 2) * 5).toFixed(1) + 'deg)';
          el.style.opacity = '0';
          el.getBoundingClientRect();
          el.style.transition = ''; el.style.transitionDelay = (i * 45) + 'ms';
        }
        el.style.transform = done; el.style.opacity = '1';
      });
    }
    function open(key){
      var spec = DATA[key]; if (!spec) return;
      window.RINear && window.RINear.clear();
      current = key; stage.innerHTML = ''; items = [];
      (spec.kind === 'fan' ? spec.items : [spec.src]).forEach(function(src){
        var d = document.createElement('div'); d.className = spec.kind === 'fan' ? spec.cls : 'kitbox__item kitbox__item--flat';
        var im = document.createElement('img'); im.src = src; im.alt = ''; d.appendChild(im); stage.appendChild(d); items.push(d);
      });
      box.classList.add('is-open'); document.body.style.overflow = 'hidden';
      apply(true);
      box.querySelector('.kitbox__close').focus();
    }
    function close(){ if (!current) return; current = null; box.classList.remove('is-open'); document.body.style.overflow = ''; stage.innerHTML = ''; items = []; }
    document.querySelectorAll('.kit__btn').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var key = btn.dataset.kit;
        if (key === 'rulebook') { window.RIReader && window.RIReader.open(); return; }
        open(key);
      });
    });
    box.addEventListener('click', function(){ close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    var rt; window.addEventListener('resize', function(){ if (!current) return; clearTimeout(rt); rt = setTimeout(function(){ apply(false); }, 120); });
  })();

  // ---- shipping map (inline SVG so the hubs can pulse and countries can be styled)
  fetch(window.RI_MAP || A + 'ri-map.svg').then(function(r){ return r.text(); }).then(function(svg){ document.getElementById('shipMap').innerHTML = svg; }).catch(function(){});
})();
